import { render, staticRenderFns } from "./InternalCertificateDetails.vue?vue&type=template&id=faee716a&scoped=true&"
import script from "./InternalCertificateDetails.vue?vue&type=script&lang=ts&"
export * from "./InternalCertificateDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InternalCertificateDetails.vue?vue&type=style&index=0&id=faee716a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faee716a",
  null
  
)

export default component.exports